import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

export const cardStyle = style({
  marginBottom: theme.spacings.m,
});

export const imageStyle = style({
  width: "40%",
  borderRadius: theme.borderRadiuses.s,
  overflow: "hidden",
});

export const imageContainerStyle = style({
  padding: `${theme.spacings.xxs2} 0`,
});

/**
 * Markdown list indent and marker styling.
 * Ordered lists omit `listStyleType` so the browser keeps decimal markers.
 */
export const markdownListStyle = recipe({
  base: {
    paddingLeft: theme.spacings.m,
  },
  variants: {
    kind: {
      ordered: {},
      unordered: {
        listStyleType: "disc",
      },
    },
  },
  defaultVariants: {
    kind: "unordered",
  },
});
